import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/services/auth.service';

@Component({
    selector: 'app-no-email-found',
    templateUrl: './no-email-found.component.html',
    styleUrls: ['./no-email-found.component.css'],
})
export class NoEmailFoundComponent implements OnInit {
    constructor(private _auth: AuthService) {}

    time = 20;

    ngOnInit(): void {
        this.createTimer();
    }

    createTimer() {
        const interval = setInterval(() => {
            this.time = this.time - 1;

            if (this.time <= 0) {
                this.redirect();
                clearInterval(interval);
            }
        }, 1000);
    }

    redirect() {
        this._auth.logout();
    }
}
